import React from 'react'
import i18n from 'i18next'
import Headline from '../../a/Headline'
import Text from '../../a/Text'
import QuestionMark from '../../svg/icons/QuestionMark'

class SearchResultError extends React.Component {
  render() {
    return (
      <div className="searchResultError">
        <QuestionMark />
        <div>
          <Headline importance={2} modifier="fragment" text={i18n.t('suche_azubi_not_found')} />
          <Text className="msg" modifier="extrasmall" text={i18n.t('suche_azubi_not_found_message')} />
        </div>
      </div>
    )
  }
}

export default SearchResultError
